import {
    call,
    put,
    select,
    takeLeading,
} from 'redux-saga/effects';

import { PayloadAction } from '@reduxjs/toolkit';

import {
    getLoanPurposes,
    getLoanPurposesFulfilled,
    getLoanPurposesRejected,
    updateLoanPurpose,
    updateLoanPurposesFulfilled,
    updateLoanPurposesRejected,
} from './loanPurposeSlice';
import { selectGetLoanPurposeUrl, selectUpdateLoanPurposeUrl } from './loanPurposeSelectors';
import { ApiResponse } from '../../utils/services';
import { LoanPurposeResponse, UpdateLoanPurposeRequest } from './loanPurposeTypes';
import { fetchLoanPurposeApi, updateLoanPurposeApi } from './loanPurposeApi';

function* getLoanPurposeSaga() {
    try {
        const url: string = yield select(selectGetLoanPurposeUrl);
        const { data }: ApiResponse<LoanPurposeResponse> = yield call(fetchLoanPurposeApi, url);

        yield put(getLoanPurposesFulfilled(data));
    } catch (e) {
        yield put(getLoanPurposesRejected());
    }
}

function* getLoanPurposeWatchSaga() {
    yield takeLeading(getLoanPurposes.type, getLoanPurposeSaga);
}

function* updateLoanPurposeSaga(action: PayloadAction<UpdateLoanPurposeRequest>) {
    const url: string | undefined = yield select(selectUpdateLoanPurposeUrl);

    if (url) {
        try {
            const { data } = yield call(updateLoanPurposeApi, url, action.payload);

            yield put(updateLoanPurposesFulfilled(data));
        } catch (e) {
            yield put(updateLoanPurposesRejected());
        }
    }
}

function* updateLoanPurposeWatchSaga() {
    yield takeLeading(updateLoanPurpose.type, updateLoanPurposeSaga);
}

export const loanPurposeSagas = [
    getLoanPurposeWatchSaga,
    updateLoanPurposeWatchSaga,
];
